/**
 * The cancellation reason is stored inside `appointment.remarks`, appended
 * after the booking notes under a fixed marker:
 *
 *   "<booking notes>\n\nCancellation remark: <reason>"
 *
 * The backend writes this format (backend/src/utils/cancellationRemark.util.ts),
 * so the marker must stay identical in both places.
 */
export const CANCELLATION_REMARK_MARKER = "Cancellation remark: ";

export interface SplitRemarks {
  notes: string;
  cancellationRemark: string | null;
}

export function splitRemarks(remarks: string | null | undefined): SplitRemarks {
  if (!remarks) {
    return { notes: "", cancellationRemark: null };
  }

  const markerIndex = remarks.indexOf(CANCELLATION_REMARK_MARKER);
  if (markerIndex === -1) {
    return { notes: remarks.trim(), cancellationRemark: null };
  }

  const notes = remarks.slice(0, markerIndex).trim();
  const cancellationRemark = remarks
    .slice(markerIndex + CANCELLATION_REMARK_MARKER.length)
    .trim();

  return { notes, cancellationRemark: cancellationRemark || null };
}
